module.exports = __webpack_public_path__ + "static/media/datos cedula_b-01.cc3c411a.svg";